import { render } from "./ProfileFilmsViewedGraphic.vue?vue&type=template&id=cb6436f2&scoped=true"
import script from "./ProfileFilmsViewedGraphic.vue?vue&type=script&lang=js"
export * from "./ProfileFilmsViewedGraphic.vue?vue&type=script&lang=js"

import "./ProfileFilmsViewedGraphic.vue?vue&type=style&index=0&id=cb6436f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6436f2"]])

export default __exports__